export const triggerHapticVibration = (duration = 200) => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;
  if ('vibrate' in navigator) {
    navigator.vibrate(duration);
  }
};
